<app-story-search-result-list
  [storySearchResult]="storySearchResult"
  [isLoading]="loading"
  [resultCount]="resultCount"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (pageEvent)="pageEventHappened($event)"
></app-story-search-result-list>
